import React from 'react'

interface InputProps {
  placeholder: string
  leftComponent?: React.ReactNode
  rightComponent?: React.ReactNode
  searchBarInput: string
  handleChange: React.ChangeEventHandler<HTMLInputElement>
  type?: string
}

const Input: React.FC<InputProps> = ({
  placeholder,
  leftComponent,
  rightComponent,
  searchBarInput,
  handleChange,
  type
}: InputProps) => (
  <div className="flex items-center relative rounded-xl border w-full border-gray-300 h-full">
    {leftComponent && (
      <div className="absolute left-[1vh] z-10 pointer-events-none">
        {leftComponent}
      </div>
    )}

    <input
      type={type ?? 'text'}
      placeholder={placeholder}
      value={searchBarInput}
      onChange={handleChange}
      className={`
        font-['Geist']
        w-full
        h-full
        rounded-xl
        border-0
        text-base
        text-gray-600
        py-1 md:py-2
        focus:outline-none
        bg-transparent
        ${leftComponent ? 'landscape:pl-14 portrait:pl-12' : 'pl-4'}
        ${rightComponent ? 'pr-14' : 'pr-4'}
      `}
    />

    {rightComponent && (
      <div className="absolute right-[1vh] z-10">
        {rightComponent}
      </div>
    )}
  </div>
)

export default Input
